module.exports = __webpack_public_path__ + "static/media/Q_2_19.e08a8788.jpg";